<div class="wrapper-header" [ngClass]="{'open': isMenuOpen}">
  <div [routerLink]="[PAGES_AND_PATHS.landingHome.pagePath]" class="header-logo">
    <img src="../../../../assets/images/landing/icon-r.svg" alt="">
  </div>
  <div class="wrapper-pages-link">
    <div class="item-header" (click)="isMenuOpen = false" [routerLink]="[PAGES_AND_PATHS.landingHome.pagePath]" routerLinkActive="active">
      <!--     TODO TRANSLATE       -->
<!--      <span>{{'HEADER.home' | translate}}</span>-->
      <span>Početna</span>
      <img src="../../../../assets/icons/landing/icon-star-header.svg" alt="">
    </div>
    <div class="item-header" (click)="isMenuOpen = false"  [routerLink]="[PAGES_AND_PATHS.landingAboutUs.pagePath]" routerLinkActive="active">
      <!--     TODO TRANSLATE       -->
<!--      <span>{{'GLOBAL.about_us' | translate}}</span>-->
      <span>O nama</span>
      <img src="../../../../assets/icons/landing/icon-star-header.svg" alt="">
    </div>
    <div class="item-header" (click)="isMenuOpen = false"  [routerLink]="[PAGES_AND_PATHS.landingBlog.pagePath]" routerLinkActive="active">
      <!--     TODO TRANSLATE       -->
<!--      <span>{{'GLOBAL.blog' | translate}}</span>-->
      <span>Blog</span>
      <img src="../../../../assets/icons/landing/icon-star-header.svg" alt="">
    </div>
    <div class="item-header" (click)="isMenuOpen = false"  [routerLink]="[PAGES_AND_PATHS.landingForBusinesses.pagePath]" routerLinkActive="active">
      <!--     TODO TRANSLATE       -->
<!--      <span>{{'GLOBAL.for_businesses' | translate}}</span>-->
      <span>Za biznise</span>
      <img src="../../../../assets/icons/landing/icon-star-header.svg" alt="">
    </div>
    <div class="item-header" (click)="isMenuOpen = false"  [routerLink]="[PAGES_AND_PATHS.landingContact.pagePath]" routerLinkActive="active">
      <!--     TODO TRANSLATE       -->
<!--      <span>{{'GLOBAL.contact' | translate}}</span>-->
      <span>Kontakt</span>
      <img src="../../../../assets/icons/landing/icon-star-header.svg" alt="">
    </div>
  </div>
  <div class="wrapper-right-header">
    <div class="wrapper-select-language">
      <!--   TODO Badza - na klik sklanjati i dodavati klasu "open" u divu ispod   -->
      <div class="wrapper-dropdown-language">
        <img src="../../../../assets/icons/language/en.png" alt="">
        <img src="../../../../assets/icons/landing/down-arrow-dropdown.svg" alt="">
        <div class="content-dropdown-language">
          <div class="item-content-dropdown-language">
            <img src="../../../../assets/icons/language/en.png" alt="">
            <span>English</span>
          </div>
          <div class="item-content-dropdown-language">
            <img src="../../../../assets/icons/language/sr.png" alt="">
            <span>Српски</span>
          </div>
        </div>
      </div>
    </div>
<!--    <button class="custom-btn custom-btn&#45;&#45;primary" (click)="isMenuOpen = false"  [routerLink]="[PAGES_AND_PATHS.login.pagePath]">-->
<!--      <span>Prijavi se</span>-->
<!--    </button>-->
    <div class="wrapper-icon-menu" (click)="isMenuOpen = !isMenuOpen">
      <img src="../../../../assets/icons/landing/icon-burgermenu.svg" alt="">
    </div>
  </div>
</div>
